<div id="Appcontainer">

	<app-authority-connection-banner *ngIf="isLogin"></app-authority-connection-banner>
	<app-apple-app-banner></app-apple-app-banner>
	<app-android-app-banner></app-android-app-banner>

	<ngx-loading-bar [color]="'#141414'" [includeSpinner]="false" [height]="'3px'"></ngx-loading-bar>
	<app-loader></app-loader>
	<app-tap-to-top></app-tap-to-top>
	<app-navigathion *ngIf="!isLogin && showLegacyPublicNav"></app-navigathion>
	<router-outlet></router-outlet>

	<!-- Fixed notification status banner (logged-in users) -->
	<div
		*ngIf="isLogin && notifBannerState"
		class="notif-banner"
		[class.notif-banner--visible]="notifBannerVisible"
		[class.notif-banner--granted]="notifBannerState === 'granted'"
		[class.notif-banner--denied]="notifBannerState === 'denied'"
		role="status"
		[attr.aria-live]="'polite'"
	>
		<div
			class="notif-banner__icon"
			[class.notif-banner__icon--granted]="notifBannerState === 'granted'"
			[class.notif-banner__icon--denied]="notifBannerState === 'denied'"
		>
			<svg *ngIf="notifBannerState === 'granted'" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
				<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
				<polyline points="22 4 12 14.01 9 11.01"/>
			</svg>
			<svg *ngIf="notifBannerState === 'request'" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
				<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
				<path d="M13.73 21a2 2 0 0 1-3.46 0"/>
			</svg>
			<svg *ngIf="notifBannerState === 'denied'" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
				<circle cx="12" cy="12" r="10"/>
				<line x1="12" y1="8" x2="12" y2="12"/>
				<line x1="12" y1="16" x2="12.01" y2="16"/>
			</svg>
		</div>

		<div class="notif-banner__body">
			<p class="notif-banner__title" *ngIf="notifBannerState === 'granted'">
				{{ 'notifications.bannerEnabledTitle' | translate }}
			</p>
			<p class="notif-banner__title" *ngIf="notifBannerState === 'request'">
				{{ 'notifications.bannerRequestTitle' | translate }}
			</p>
			<p class="notif-banner__title" *ngIf="notifBannerState === 'denied'">
				{{ 'notifications.bannerDeniedTitle' | translate }}
			</p>
			<p class="notif-banner__sub" *ngIf="notifBannerState === 'granted'">
				{{ 'notifications.bannerEnabledSub' | translate }}
			</p>
			<p class="notif-banner__sub" *ngIf="notifBannerState === 'request'">
				{{ 'notifications.bannerRequestSub' | translate }}
			</p>
			<p class="notif-banner__sub" *ngIf="notifBannerState === 'denied'">
				{{ 'notifications.bannerDeniedSub' | translate }}
			</p>
		</div>

		<div class="notif-banner__actions">
			<button
				*ngIf="notifBannerState === 'request'"
				class="notif-banner__btn notif-banner__btn--allow"
				type="button"
				(click)="allowNotifications()"
			>
				{{ 'notifications.allow' | translate }}
			</button>
			<button
				class="notif-banner__btn notif-banner__btn--close"
				type="button"
				(click)="dismissNotifBanner()"
				[attr.aria-label]="'notifications.dismiss' | translate"
			>
				<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
					<line x1="18" y1="6" x2="6" y2="18"/>
					<line x1="6" y1="6" x2="18" y2="18"/>
				</svg>
			</button>
		</div>
	</div>

</div>
